"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddressFormSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
const checkMarkSize = 24;
const fieldHeight = 56;
const getFlexStyles = (theme)=>({
        alignItems: 'center',
        display: 'flex',
        gap: theme.spacing(5),
        justifyContent: 'start',
        width: '100%'
    });
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        ...getFlexStyles(theme),
        flexFlow: 'column'
    };
});
const PrimaryAddressSkeleton = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        ...getFlexStyles(theme),
        flexFlow: 'row'
    };
});
const ButtonSkeleton = (0, _mui.styled)(_mui.Skeleton)({
    borderRadius: 100
});
const AddressFormSkeleton = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        "data-testid": getTestId(_models.TestId.AddressFormSkeleton),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                animation: "wave",
                height: fieldHeight,
                variant: "rounded",
                width: "100%"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                animation: "wave",
                height: fieldHeight,
                variant: "rounded",
                width: "100%"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PrimaryAddressSkeleton, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                        animation: "wave",
                        height: checkMarkSize,
                        variant: "rectangular",
                        width: checkMarkSize
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                        animation: "wave",
                        variant: "text",
                        width: "50%"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonSkeleton, {
                animation: "wave",
                variant: "rounded",
                height: 45,
                width: 330
            })
        ]
    });
};
exports.AddressFormSkeleton = AddressFormSkeleton;
